type StreakType = 'dayStreak' | 'weekStreak';

export const getRelevantStreak = (
    dayStreakCount: number,
    weekStreakCount: number,
): { type: StreakType; value: number } => {
    if (dayStreakCount > 1) {
        return { type: 'dayStreak', value: dayStreakCount };
    }

    return { type: 'weekStreak', value: weekStreakCount };
};
